import request from '@/config/axios'

// 景点
export const getScenicSpotPage = (params: any) => {
  return request.get({ url: '/scenic/spot/page', params })
}

// 全部已发布景点（不分页，供选择器使用）
// 注：带 _t 时间戳防止浏览器/代理缓存 GET，确保能拉到最新数据
export const getScenicSpotListSimple = () => {
  return request.get({ url: '/scenic/spot/simple-list', params: { _t: Date.now() } })
}

export const getScenicSpot = (id: number) => {
  return request.get({ url: '/scenic/spot/get', params: { id } })
}

/** 获取娱乐项目详情：错误提示按“项目不存在”展示 */
export const getScenicProject = (id: number) => {
  return request
    .get({ url: '/scenic/spot/get', params: { id }, custom: { showError: false } })
    .catch(() => {
      throw new Error('项目不存在')
    })
}

export const createScenicSpot = (data: any) => {
  return request.post({ url: '/scenic/spot/create', data })
}

export const updateScenicSpot = (data: any) => {
  return request.put({ url: '/scenic/spot/update', data })
}

export const deleteScenicSpot = (id: number) => {
  return request.delete({ url: '/scenic/spot/delete', params: { id } })
}

export const deleteScenicSpotList = (ids: number[]) => {
  return request.delete({ url: '/scenic/spot/delete-list', params: { ids: ids.join(',') } })
}

export const updateScenicSpotStatus = (id: number, status: number) => {
  return request.put({ url: '/scenic/spot/update-status', params: { id, status } })
}

export const getScenicSpotTree = () => {
  return request.get({ url: '/scenic/spot/tree' })
}

export const exportScenicSpotExcel = (params: any) => {
  return request.download({ url: '/scenic/spot/export-excel', params })
}
